import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { classNames, TruncateText, FaIcon } from '@panwds/react-ui';

var PillValue = forwardRef(function (props, ref) {
    var isOpen = props.isOpen, label = props.label, rest = __rest(props, ["isOpen", "label"]);
    var toggleClassName = classNames("tw-text-default tw-leading-3 tw-ml-2 tw-duration-150 tw-transform", isOpen ? "tw--rotate-180" : "tw-rotate-0");
    var buttonClassName = classNames("tw-font-lato tw-box-border tw-border-solid tw-border-gray-300 tw-m-0 tw-flex tw-leading-5 tw-w-full tw-items-center tw-h-8 tw-min-w-0 tw-pl-2 tw-pr-3 tw-pb-0 tw-pt-0 tw-bg-white dark:tw-bg-gray-1000", "tw-border tw-rounded-r-full focus:tw-outline-none dark:tw-border-gray-700", rest.disabled
        ? "tw-cursor-not-allowed tw-text-disabled dark:tw-text-dark-bg-disabled"
        : "focus:tw-ring hover:tw-bg-blue-100 hover:tw-border-blue-700 tw-text-link dark:tw-text-dark-bg-link");
    return (React.createElement("button", __assign({ className: buttonClassName, "data-testid": "filter-value", style: { minWidth: "4rem", maxWidth: "16rem" }, ref: ref }, rest, { type: "button" }),
        React.createElement(TruncateText, { appearance: "dark" }, label),
        !rest.disabled && (React.createElement("div", null,
            React.createElement(FaIcon, { "data-testid": "toggle", addClassName: toggleClassName, size: "xs", faIconDef: faAngleDown })))));
});
PillValue.displayName = "PillValue";

export { PillValue };
//# sourceMappingURL=PillValue.esm.js.map
